import { Box, Button } from '@mui/material';

import { HeaderWrapper, HeaderLogo, HeaderLinks } from './styles';
import { logoAlluraDirect } from 'config/imageUrls';

import { useToggle } from '@alluradirect/react';
import { PageHeaderHelpDialog } from 'components/layout/Page/components/PageHeaderHelpDialog';

export const TopNavLinks = () => {

  const helpToggle = useToggle();

  return (
    <>
      <HeaderWrapper container>
        <HeaderLogo item xs={12} sm={4}>
          <a href="https://www.alluraDirect.com">
            <img src={logoAlluraDirect} />
          </a>
        </HeaderLogo>
        <HeaderLinks item xs={12} sm={8}>
          <Box>
            <Button variant="text" color="secondary" onClick={helpToggle.open}>
              Contact
            </Button>
            <Button variant="contained" color="secondary" href="/list">
              List Your Property
            </Button>
          </Box>
        </HeaderLinks>
      </HeaderWrapper>
      {helpToggle.isOpen ? <PageHeaderHelpDialog isOpen={helpToggle.isOpen} close={helpToggle.close} /> : null}
    </>
  );
};
